import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const ProductBasicInfoSchema_ = z.object({
  productId: z.string(),
  productTitle: z.string(),
  productImage: z.string().optional(),
});

const ProductReturnMappingSchema = z.object({
  productId: z.string(),
  returnId: zExt.objectId(),
});

export const getProductsBasicInfo = {
  name: "getProductsBasicInfo" as const,
  input: z.object({
    productReturnMappings: z.array(ProductReturnMappingSchema),
  }),
  output: z.array(ProductBasicInfoSchema_),
};

export interface ProductBasicInfo
  extends z.infer<typeof ProductBasicInfoSchema_> {}
